<template>
	<Modal
		v-if="visible"
		:hide-actions="true"
		:allow-close="true"
		@modal:close="handleClose()"
	>
		<template #body>
			<div class="font-[Inter] text-2xl font-semibold text-won-blue">Select a Resume Template</div>
			<div class="mt-2.5 font-[Inter] text-sm font-normal text-won-blue">
				Click to select a resume from the {{ templates.length }} templates, then click on next to customize it with ResumAI!
			</div>

			<div class="flex flex-col gap-y-6">
				<div class="mt-6 grid grid-cols-2 gap-4">
					<div
						v-for="item of templates"
						:key="item.name"
						class="h-[228px] rounded bg-white"
						:class="[{
							'border border-[#c2c4c6]': new String(item.name).toLocaleLowerCase()!=currentSelectedTemplate,
							'border border-won-green': new String(item.name).toLocaleLowerCase()==currentSelectedTemplate
						}]"
						@click="() => handleSelect(item.name)"
					>
						<div class="h-[185px] w-full overflow-hidden px-2 py-3">
							<img
								:alt="item.name"
								:src="`/storage/${item.preview}`"
							/>
						</div>
						<div class="flex flex-row items-center px-2">
							<span class="w-full truncate font-[Roboto] text-base font-medium text-won-blue">
								{{ localNames[new String(item.name).toLocaleLowerCase()] }}
							</span>
							<svg
								width="14"
								height="14"
								viewBox="0 0 14 14"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							>
								<path
									d="M12.4642 12.3658H1.96423V1.86584H7.21423V0.365845H1.96423C1.13173 0.365845 0.464233 1.04084 0.464233 1.86584V12.3658C0.464233 13.1908 1.13173 13.8658 1.96423 13.8658H12.4642C13.2892 13.8658 13.9642 13.1908 13.9642 12.3658V7.11585H12.4642V12.3658ZM8.71423 0.365845V1.86584H11.4067L4.03423 9.23835L5.09173 10.2958L12.4642 2.92335V5.61585H13.9642V0.365845H8.71423Z"
									fill="#929497"
								/>
							</svg>
						</div>
					</div>
				</div>
    
				<div class="my-4 w-full">
					<won-button
						class="w-full"
						@click="() => handleNext()"
					>
						<svg
							v-if="submitting"
							class="mr-3 -ml-1 size-5 animate-spin text-white"
							xmlns="http://www.w3.org/2000/svg"
							fill="none"
							viewBox="0 0 24 24"
						>
							<circle
								class="opacity-25"
								cx="12"
								cy="12"
								r="10"
								stroke="currentColor"
								stroke-width="4"
							/>
							<path
								class="opacity-75"
								fill="currentColor"
								d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
							/>
						</svg>
						Next
					</won-button>
				</div>
			</div>
		</template>
	</Modal>
</template>

<script setup>
import { onMounted, toRefs, ref } from 'vue';

import Modal from '../components/modal.vue';
import WonButton from '../components/won-button';

const props = defineProps({
	templates: {
		type: Array,
		required: true
	},
	visible: {
		type: Boolean,
		default: false,
	},
	currentTemplate: {
		type: String,
		default: localStorage.getItem('defaultTemplate')
	}
});

const localNames = {
	basic: 'Wonsulting Resume',
	standart: 'UW Standard Resume',
	technical: 'UW Technical Resume',
};

const { visible, currentTemplate, templates } = toRefs(props);
const emit = defineEmits(['change', 'close']);

const submitting = ref(false);
const currentSelectedTemplate = ref(currentTemplate.value);

onMounted(async() => {
	document.onkeydown = function(e) {
		if (e.key === 'Escape' && visible.value) {
			handleClose();
		}
	};
});

const handleSelect = (template) => {
	currentSelectedTemplate.value = new String(template).toLowerCase();
};

const handleNext = () => {
	submitting.value = true;
	setTimeout(() => {
		handleClose();
		submitting.value = false;

		emit('change', { template: currentSelectedTemplate.value });
	}, 500);
};

const handleClose = () => {
	emit('close');
};
</script>
